import React, { SVGProps } from 'react'
const SvgVirtualCardAndBudgetGrayscale = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={83}
    height={75}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#VirtualCardAndBudgetGrayscale_svg__a)">
      <path
        fill="#EAEBF1"
        fillRule="evenodd"
        d="M77.704 11H65.207C64.54 11 64 11.54 64 12.207v1.69c0 .666.54 1.206 1.207 1.206h12.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207ZM77.704 56H45.207C44.54 56 44 56.54 44 57.207v1.69c0 .666.54 1.206 1.207 1.206h32.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207ZM24.704 48H2.207C1.54 48 1 48.54 1 49.207v1.69c0 .666.54 1.206 1.207 1.206h22.497c.666 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207Z"
        clipRule="evenodd"
      />
      <g filter="url(#VirtualCardAndBudgetGrayscale_svg__b)">
        <path
          fill="#000"
          d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
        />
      </g>
      <path
        fill="#fff"
        d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
      />
      <g filter="url(#VirtualCardAndBudgetGrayscale_svg__c)">
        <circle
          cx={28.084}
          cy={26.462}
          r={23.323}
          fill={props.fill || '#B3B7BE'}
        />
        <g filter="url(#VirtualCardAndBudgetGrayscale_svg__d)">
          <path
            fill="#fff"
            d="M7.886 14.8a23.324 23.324 0 0 0-.471 22.467l20.67-10.805L7.884 14.8Z"
          />
        </g>
        <mask
          id="VirtualCardAndBudgetGrayscale_svg__e"
          width={110}
          height={93}
          x={-26}
          y={-20}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill="#82DCC9"
            fillRule="evenodd"
            d="m57.5-19.447-82.677 43.222.216.414 82.677-43.223-.216-.413Zm.432.826-82.677 43.223.216.413 82.677-43.222-.216-.414Zm-82.245 44.05 82.678-43.223.216.413-82.678 43.223-.216-.413Zm83.11-42.396-82.678 43.223.216.413 82.678-43.223-.216-.413Zm-82.246 44.05L59.23-16.14l.216.413-82.677 43.223-.217-.414Zm83.11-42.397L-23.016 27.91l.216.414L59.877-14.9l-.216-.414Zm-82.245 44.05 82.677-43.223.217.414-82.678 43.222-.216-.413Zm83.11-42.396-82.678 43.223.216.413 82.678-43.223-.216-.413ZM-21.72 30.39l82.678-43.223.216.413-82.677 43.223-.217-.413Zm83.11-42.397-82.677 43.223.216.414 82.677-43.223-.216-.414Zm-82.245 44.05L61.822-11.18l.216.414-82.677 43.222-.216-.413Zm83.11-42.396L-20.423 32.87l.216.413L62.471-9.94l-.216-.413Zm-82.246 44.05L62.687-9.526l.216.413-82.678 43.223-.216-.413ZM63.12-8.7l-82.677 43.222.216.414L63.335-8.286l-.216-.413Zm-82.245 44.05L63.55-7.874l.216.414-82.677 43.223-.216-.414Zm83.11-42.397-82.678 43.223.216.413L64.2-6.632l-.216-.414Zm-82.246 44.05L64.416-6.22l.216.413-82.678 43.223-.216-.413Zm83.11-42.396L-17.83 37.83l.216.413L65.064-4.98l-.216-.413Zm-82.245 44.05L65.28-4.567l.216.414L-17.18 39.07l-.216-.414ZM65.713-3.74l-82.678 43.223.216.413L65.929-3.325l-.216-.414Zm-82.246 44.05L66.145-2.912l.216.413-82.678 43.223-.216-.413Zm83.11-42.396-82.678 43.223.216.413L66.793-1.672l-.216-.413Zm-82.245 44.05L67.009-1.259l.216.413-82.677 43.223-.216-.414ZM67.442-.433l-82.678 43.223.216.414L67.657-.018l-.216-.414Zm-82.246 44.05L67.874.395l.216.414-82.678 43.222-.216-.413Zm83.11-42.396-82.678 43.223.216.413L68.522 1.635l-.216-.413Zm-82.246 44.05L68.738 2.048l.216.413-82.677 43.223-.217-.414ZM69.17 2.874l-82.677 43.223.216.414L69.386 3.289l-.216-.414Zm-82.245 44.05L69.603 3.702l.216.414-82.678 43.222-.216-.413ZM70.035 4.53l-82.678 43.223.216.413L70.251 4.942l-.216-.413Zm-82.246 44.05L70.467 5.355l.216.413-82.677 43.223-.217-.413ZM70.9 6.182l-82.677 43.222.216.414L71.115 6.596l-.216-.413Zm-82.245 44.05L71.33 7.008l.216.414-82.677 43.223-.216-.414Zm83.11-42.397L-10.914 51.06l.216.413L71.98 8.25l-.216-.414Zm-82.246 44.05L72.196 8.663l.216.413L-10.266 52.3l-.216-.413ZM72.628 9.49l-82.677 43.222.216.414L72.844 9.903l-.216-.413ZM-9.617 53.54 73.06 10.315l.216.414L-9.4 53.953l-.216-.414Zm83.11-42.397L-9.185 54.366l.216.413L73.71 11.557l-.216-.414Zm-82.246 44.05L73.925 11.97l.216.413-82.678 43.223-.216-.413Zm83.11-42.396L-8.32 56.019l.216.414L74.573 13.21l-.216-.413Zm-82.245 44.05 82.677-43.224.216.414L-7.672 57.26l-.216-.414Zm83.11-42.397L-7.456 57.673l.216.413 82.678-43.222-.216-.414ZM-7.024 58.5l82.678-43.223.216.414-82.678 43.222-.216-.413Zm83.11-42.396L-6.592 59.327l.216.413 82.678-43.223-.216-.413Zm-82.245 44.05L76.518 16.93l.216.413-82.677 43.223-.216-.414Zm83.11-42.397L-5.728 60.98l.216.414L77.167 18.17l-.217-.414Zm-82.246 44.05 82.678-43.223.216.414L-5.08 62.22l-.216-.413Zm83.11-42.396L-4.863 62.634l.216.413 82.678-43.223-.216-.413Zm-82.246 44.05 82.678-43.223.216.413-82.677 43.223-.217-.413Zm83.11-42.396L-3.998 64.287l.216.414 82.677-43.223-.216-.414Zm-82.245 44.05L79.112 21.89l.216.414L-3.35 65.528l-.216-.414Zm83.11-42.397L-3.134 65.941l.216.413L79.76 23.132l-.216-.414Zm-82.246 44.05 82.678-43.223.216.413-82.677 43.223-.217-.413Zm83.11-42.396L-2.269 67.594l.216.414 82.677-43.223-.216-.413Zm-82.245 44.05L80.84 25.197l.216.414L-1.62 68.835l-.216-.414Zm83.11-42.397L-1.405 69.248l.216.413L81.49 26.44l-.216-.414ZM-.973 70.075l82.678-43.223.216.413L-.757 70.488l-.216-.413Zm83.11-42.396L-.54 70.9l.216.414 82.677-43.223-.216-.413ZM-.108 71.729l82.677-43.224.216.414L.108 72.142l-.216-.414Zm83.11-42.397L.324 72.555l.216.413 82.678-43.222-.216-.414Z"
            clipRule="evenodd"
          />
        </mask>
        <g mask="url(#VirtualCardAndBudgetGrayscale_svg__e)">
          <path
            fill={props.fill || '#B3B7BE'}
            d="M7.886 14.8a23.324 23.324 0 0 0-.471 22.467l20.67-10.806L7.884 14.8Z"
          />
        </g>
        <g filter="url(#VirtualCardAndBudgetGrayscale_svg__f)">
          <path
            fill={props.fill || '#697080'}
            d="M39.746 6.263A23.323 23.323 0 0 0 7.886 14.8l20.198 11.662 11.662-20.2Z"
          />
        </g>
      </g>
      <g filter="url(#VirtualCardAndBudgetGrayscale_svg__g)">
        <g filter="url(#VirtualCardAndBudgetGrayscale_svg__h)">
          <path
            fill="#000"
            d="m75.623 24.109-46.976 8.283a1.15 1.15 0 0 0-.933 1.332l5.331 30.235a1.15 1.15 0 0 0 1.332.932l46.976-8.283a1.15 1.15 0 0 0 .933-1.332l-5.331-30.235a1.15 1.15 0 0 0-1.332-.932Z"
          />
        </g>
        <path
          fill={props.fill || '#697080'}
          d="m75.623 24.109-46.976 8.283a1.15 1.15 0 0 0-.933 1.332l5.331 30.235a1.15 1.15 0 0 0 1.332.932l46.976-8.283a1.15 1.15 0 0 0 .933-1.332l-5.331-30.235a1.15 1.15 0 0 0-1.332-.932Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m48.953 44.642-14.77 2.604a.575.575 0 0 0-.467.666l.137.773a.575.575 0 0 0 .666.466l14.77-2.604a.575.575 0 0 0 .466-.666l-.136-.773a.575.575 0 0 0-.666-.466Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m38.883 34.45-6.747 1.19a.575.575 0 0 0-.466.665l.535 3.038a.575.575 0 0 0 .666.467l6.747-1.19a.575.575 0 0 0 .466-.666l-.536-3.038a.575.575 0 0 0-.666-.466ZM73.895 28.276l-6.746 1.19a.575.575 0 0 0-.466.666l.188 1.068a.575.575 0 0 0 .666.466l6.746-1.19a.575.575 0 0 0 .466-.665l-.188-1.069a.575.575 0 0 0-.666-.466Z"
          clipRule="evenodd"
          opacity={0.75}
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M69.117 46.864 35.17 52.85a.575.575 0 0 0-.466.665l.136.773a.575.575 0 0 0 .666.467l33.947-5.986a.575.575 0 0 0 .466-.666l-.136-.773a.575.575 0 0 0-.666-.466Z"
          clipRule="evenodd"
        />
        <path
          fill="url(#VirtualCardAndBudgetGrayscale_svg__i)"
          fillRule="evenodd"
          d="m42.672 57.304-6.514 1.149a.575.575 0 0 0-.466.665l.137.773a.575.575 0 0 0 .665.467l6.514-1.149a.575.575 0 0 0 .466-.666l-.137-.773a.575.575 0 0 0-.665-.466Z"
          clipRule="evenodd"
          opacity={0.75}
        />
        <path
          fill="url(#VirtualCardAndBudgetGrayscale_svg__j)"
          fillRule="evenodd"
          d="m62.475 53.812-6.513 1.149a.575.575 0 0 0-.466.666l.136.773a.575.575 0 0 0 .666.466l6.513-1.148a.575.575 0 0 0 .466-.666l-.136-.773a.575.575 0 0 0-.666-.467Z"
          clipRule="evenodd"
          opacity={0.75}
        />
      </g>
    </g>
    <defs>
      <filter
        id="VirtualCardAndBudgetGrayscale_svg__b"
        width={79}
        height={80}
        x={3}
        y={-4}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_432"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_432"
          result="shape"
        />
      </filter>
      <filter
        id="VirtualCardAndBudgetGrayscale_svg__c"
        width={52.245}
        height={51.778}
        x={1.878}
        y={1.544}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.933} />
        <feGaussianBlur stdDeviation={1.166} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_432"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_432"
          result="shape"
        />
      </filter>
      <filter
        id="VirtualCardAndBudgetGrayscale_svg__d"
        width={27.988}
        height={27.132}
        x={1.962}
        y={13.867}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.466} dy={1.399} />
        <feGaussianBlur stdDeviation={1.166} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_432"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_432"
          result="shape"
        />
      </filter>
      <filter
        id="VirtualCardAndBudgetGrayscale_svg__f"
        width={36.525}
        height={27.988}
        x={5.087}
        y={2.205}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.466} dy={1.399} />
        <feGaussianBlur stdDeviation={1.166} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_432"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_432"
          result="shape"
        />
      </filter>
      <filter
        id="VirtualCardAndBudgetGrayscale_svg__g"
        width={58.607}
        height={44.817}
        x={25.697}
        y={24.091}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_432"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_432"
          result="shape"
        />
      </filter>
      <filter
        id="VirtualCardAndBudgetGrayscale_svg__h"
        width={60.607}
        height={46.817}
        x={24.697}
        y={23.091}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_432"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_432"
          result="shape"
        />
      </filter>
      <linearGradient
        id="VirtualCardAndBudgetGrayscale_svg__i"
        x1={41.48}
        x2={37.401}
        y1={58.496}
        y2={59.216}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="VirtualCardAndBudgetGrayscale_svg__j"
        x1={61.283}
        x2={57.204}
        y1={55.005}
        y2={55.724}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <clipPath id="VirtualCardAndBudgetGrayscale_svg__a">
        <path fill="#fff" d="M0 0h83v75H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgVirtualCardAndBudgetGrayscale
